import { module } from 'angular';
import { CheckDropdownSelectComponent } from './check-dropdown-select.component';
import { GmcIndeterminateModule } from '../../shared/directives/gmc-indeterminate/gmc-indeterminate.module';
import { checkDropdownOptionDirective } from './check-dropdown-option.directive';

export const CheckDropdownSelectModule = module('app.ui.check-dropdown-select', [
  GmcIndeterminateModule
])
  .component('checkDropdownSelect', CheckDropdownSelectComponent)
  .directive('checkDropdownOption', checkDropdownOptionDirective)
  .name;



// WEBPACK FOOTER //
// ./app/ui/check-dropdown-select/check-dropdown-select.module.ts